'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import { TacSdk, Network, SenderFactory } from '@tonappchain/sdk';
import { TonConnectUI } from '@tonconnect/ui';
// import { ethers } from 'ethers';
import { Loading } from '../Loading';
// import { TonClient } from '@ton/ton';
// import { Api, HttpClient, Event } from 'tonapi-sdk-js';
// import { TonApiClient } from '@ton-api/client';
// import { ContractAdapter } from '@ton-api/ton-adapter';

// Create context for TAC SDK
export const TacSdkContext = createContext<{
  tacSdk: TacSdk | null;
  isInitializing: boolean;
  error: string | null;
  createSender: (tonConnectUI: TonConnectUI) => Promise<SenderFactory>;
}>({
  tacSdk: null,
  isInitializing: true,
  error: null,
  createSender: async () => {
    throw new Error('createSender must be used within a TacSdkProvider');
  }
});

export function useTacSdk() {
  const context = useContext(TacSdkContext);
  if (!context) {
    throw new Error('useTacSdk must be used within a TacSdkProvider');
  }
  return context;
}

export function TacSdkProvider({
  children,
  network = Network.TESTNET
}: {
  children: React.ReactNode;
  network?: Network;
}) {
  const [tacSdk, setTacSdk] = useState<TacSdk | null>(null);
  const [isInitializing, setIsInitializing] = useState(true);
  const [error, setError] = useState(null);

  async function initializeSdk() {
    try {
      if (tacSdk) return;
      setIsInitializing(true);
      // Initialize TAC SDK

      // const ta = new TonApiClient({
      //   baseUrl: 'https://tonapi.io',
      //   apiKey: 'AFEU7Q6SXYYWVAQAAAALIRLTHKYUA56BHOZ3ZGWAWMLJB64RXADLKC3RNDO2NJRHQCJCLZI'
      // });

      // const tonClient = new ContractAdapter(ta);
      const sdk = await TacSdk.create({
        // TONParams: {
        //   contractOpener: tonClient
        //   // contractOpener: new TonClient({
        //   //   // endpoint: 'https://toncenter.com/api/v2/jsonRPC',
        //   //   // apiKey: '33788c51c650d0d6d11b9e0f672f9d6f1b453049767eb7d3b205425081ade3e5' // Optional but recommended for production
        //   // })
        // }
        // network: Network.TESTNET,
        network: network
        // customLiteSequencerEndpoints: ['http://34.203.126.155:8081'],
        // TACParams: {
        //   provider: new ethers.JsonRpcProvider('http://34.203.126.155:8545'),
        //   settingsAddress: '0x9c57864c160DDaEecff1bB9f4ab86a431D9588c8'
        // },
        // TONParams: {
        //   settingsAddress: 'EQBoFw42dxrFcBH4Wqdm7NNKxIwj6fMnl-2zIPs02Xrf_HPG'
        // }
      });

      setTacSdk(sdk);
      setError(null);
    } catch (err: any) {
      console.error('Failed to initialize TAC SDK:', err);
      setError(err.message || 'Failed to initialize TAC SDK');
    } finally {
      setIsInitializing(false);
    }
  }

  useEffect(() => {
    initializeSdk();

    // Cleanup function
    return () => {
      if (tacSdk) {
        // Close any open connections
        tacSdk.closeConnections();
      }
    };
  }, [network, tacSdk]);

  // Create a sender from TON wallet
  async function createSender(tonConnectUI: TonConnectUI) {
    if (!tonConnectUI) {
      throw new Error('TON Connect UI instance required');
    }

    const sender = await SenderFactory.getSender({
      tonConnect: tonConnectUI
    });

    return sender;
  }

  const value = {
    tacSdk,
    isInitializing,
    error,
    createSender
  };

  console.log(isInitializing, 'init sdk');

  return <TacSdkContext.Provider value={value}>{isInitializing ? <Loading /> : children}</TacSdkContext.Provider>;
}
